define('views/filter-modal',["exports", "backbone", "bootstrap/modal", "rivets"], function (_exports, _backbone, _modal, _rivets) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _modal = _interopRequireDefault(_modal);
  _rivets = _interopRequireDefault(_rivets);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
  function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, e) { if ("object" != typeof t || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
  var _default = _exports.default = _backbone.View.extend({
    events: {
      'click .btn-filter--primary'() {
        this.hide();
        this.listState.applyFilter();
      },
      'click .modal-filter__header-btn-close'() {
        this.hide();
        this.listState.backFilter();
      },
      'click .btn-filter--reset'() {
        this.hide();
        this.listState.resetFilter();
      },
      'click .control-switch__btn'(ev) {
        return this._clickSwitchBtn(ev);
      },
      'click .bounds-reset'() {
        this.listState.unset('bounds');
      }
    },
    initialize(options) {
      this.listState = options.listState;
      this.modal = new _modal.default(this.el, _objectSpread(_objectSpread({}, _modal.default.DEFAULTS), {}, {
        show: false
      }));
      this.el.addEventListener('show.bs.modal', () => {
        this._initControls();
        this.binding = _rivets.default.bind(this.el, {
          f: this.listState
        });
      }, {
        once: true
      });
    },
    destroy() {
      this.hide();
      this._finiControls();
      if (this.binding) {
        this.binding.unbind();
      }
    },
    show() {
      this.listState.set('modal', true);
      this.modal.show();
    },
    hide() {
      this.modal.hide();
      this.listState.set('modal', false);
    }
  });
});//# sourceMappingURL=filter-modal.js.map
;
